import { getLegacyStatus } from '../utils/statusMapping';

export const getStatus = (adminStatus, transactionStatus) => {
    return getLegacyStatus(adminStatus, transactionStatus);
};

export const WorkStatus = (data) => {
    switch (data) {
        case 0:
            return 'pending'
            break;
        case 1:
            return 'approved'
            break;
        case 2:
            return 'failed'
            break;
        default:
            break;
    }
}

export const VerificationStatusClassUpdate = (data) => {
    switch (data) {
        case 1:
            return 'verification_success'
            break
        case 0:
            return 'verification_pending'
            break
        case 2:
            return 'verification_failed'
            break
        case 4:
            return 'verification_review'
        default:
            break
    }
}
export const singlePageStatusUpdate = (data) => {
    switch (data) {
        case 'active':
            return 'verification_success'
            break
        case 'pending':
            return 'verification_review'
            break
        case 'rejected':
            return 'verification_failed'
            break
        default:
            break
    }
}

export const catalogStatusUpdate = (data) => {
    switch (data) {
        case 0:
        case 4:
            return {
                message: 'Your Catalogue is Under Review',
                className: 'in_review'
            };
        case 2:
            return {
                message: 'Catalogue rejected by Admin',
                className: 'rejected'
            };
        case 1: 
        return {
            
        }
        default:
            return {
                message: 'Unknown status',
                className: 'status-unknown'
            };
    }
};
